import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import { InputCurrency } from '@/components/ui/InputCurrency';
import InstructionHint from '@/components/ui/InstructionHint';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const HOW_MUCH_INSURER_PAID_NAME = 'how_much_insurer_paid';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const InputHowMuchTheInsurerPaid: FC<Props> = ({
  name = HOW_MUCH_INSURER_PAID_NAME,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
        validate: (value) =>
          Number.isNaN(parseFloat(value))
            ? i18n.t('Wartość musi być liczbą.')
            : undefined,
      }}
      render={({ field }) => {
        return (
          <FormItem>
            <FormLabel>
              {i18n.t('Jaką kwotę wypłacił ubezpieczyciel?')}
            </FormLabel>
            <InstructionHint
              title={i18n.t(
                'Wpisz przybliżoną wartość kwoty, którą wypłacił ubezpieczyciel.'
              )}
            />
            <FormControl>
              <InputCurrency
                label={i18n.t('Kwota odszkodowania')}
                {...field}
                className="lg:max-w-[300px]"
                data-testid={`${name}-input`}
              />
            </FormControl>
          </FormItem>
        );
      }}
    />
  );
};
